<template>
  <div class="AnalogValueAnalysis mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/AV001"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
        <el-main>
          <div class="mainWrao">
            <div class="recordTitle">
              <h1>{{$t('leftNav.navFourteen')}}</h1>
              <div class="machineSeach">
                <label style="margin-right:10px;font-size:12px;">{{$t('SingleTireStepAnalysis.labelTitle')}}</label>
                <!-- <el-cascader
                  class="idStyle"
                  @change="getShiftTime(machineID)"
                  :placeholder="$t('SingleTireStepAnalysis.placehoder1')"
                  expand-trigger="hover"
                  :options="options"
                  filterable
                  v-model="machineID">
                </el-cascader> -->
                <equipment @change="getchange" class="machinevue" :machine="machineID[1]"></equipment>
              </div>
            </div>
            <!-- 页面主体部分-->
            <div class="my">
              <div class="mynavlist">
                <div class="navlistleft">
                  <!-- EventCode -->
                  <!-- <div class="searchers">
                    <el-select 
                      v-model="searchvalue" 
                      @change="getEventcode(searchvalue)" 
                      id="EventCode" 
                      filterable 
                      :placeholder="$t('AnalogValueAnalysis.EventCode')"
                    >
                      <el-option
                        v-for="item in searcherslist"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </div> -->
                  <!-- date -->
                  <div class="searchnavdate">
                    <div class="block">
                      <el-date-picker 
                        v-model="datevalue"
                        type="date"
                        :placeholder="$t('AnalogValueAnalysis.Choosedate')"
                        @change="kongdata(datevalue)"
                        >
                      </el-date-picker>
                    </div>
                  </div>
                  <!-- time -->
                  <div class="searchnavtime">
                    <el-time-picker
                      v-model="timevalue"
                      :placeholder="$t('AnalogValueAnalysis.Choosetime')"
                      @change="kongtime(timevalue)"
                      >
                    </el-time-picker>
                  </div>
                  <!-- EventCode -->
                  <div class="searchers">
                    <el-select 
                      v-model="searchvalue" 
                      @change="getEventcode(searchvalue)" 
                      id="EventCode" 
                      filterable 
                      :placeholder="$t('AnalogValueAnalysis.EventCode')"
                    >
                      <el-option
                        v-for="item in searcherslist"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </div>
                </div>  
                <div class="navlistright">
                  <el-button v-if='false' :plain="true" @click="open4"></el-button> <!--隐藏 -->
                  <el-button v-if='false' :plain="true" @click="open3"></el-button> <!--查无数据 -->
                  <el-button type="primary" class="searchstart" icon="el-icon-view" @click="searchstart">{{$t('AnalogValueAnalysis.show')}}</el-button>
                </div>
              </div>
              <div class="importantbody" v-show="importantbody">
                <div class="selectsort">{{machineName}}  {{$t('AnalogValueAnalysis.EventCode')}}:<span>{{searchvalue}}</span></div>
                <div class="selecttime"><span>{{datevalue1}}</span><span class="blank">{{timevalue1}}~{{timevalue2}}</span></div>
                <!-- echarts图表 -->
                <div id="myecharts" v-loading="myecharts"></div>
              </div>
            </div>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>

<script>
import leftNav from "@/components/nav.vue"
import equipment from "@/components/Equipment.vue"

export default {
  name: 'AnalogValueAnalysis',
  components: {
    leftNav,
    equipment
  },
  data () {
    return {
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [],
      fullscreenLoading: false,
      //我的代码
        searchvalue:'',
        searcherslist:[],
        datevalue:'',//日期
        timevalue:'',//时间
        datevalue1:'',
        timevalue1:'',
        timevalue2:'',
        importantbody:false,
        myecharts:false,//echarts图表
        tbmid:'',
        machineName:'',
        searchid:'',
        timeArr : [],//echarts图表的x轴
        numArr : [],//echarts图表的y轴
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    },
    datevalue(){
      this.datevaluechange()
    },
    timevalue(){
      this.timevaluechange()
    }
  },
  mounted() {
    this.$store.commit('authority' , this.$route.path)
    this.getManiceList()
    this.searchers()
    this.initChart()
  },
  destroyed() {
  },
  methods: {
    // 切换设备
    getchange(value){
      this.machineID[0]=Number(this.$store.state.defaultFactoryId)
      this.machineID[1]=value
      this.getShiftTime(this.machineID)
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(localStorage.getItem('isMarketAccount') === '1') {
            _this.$store.commit('marketAccount',res.data.options)
          }
          _this.options = res.data.options
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    getShiftTime(x){//动态绑定EventCode
      this.tbmid = x[1]
      let a = x[0]
      let arra = this.options.filter((item)=>{
        return item.value == a
      })
      let childrenarr = arra[0].children
      let brrb = childrenarr.filter((item)=>{
        return item.value == x[1]
      })
      this.machineName = brrb[0].label
    },
    getEventcode(y){
      this.searchid = y
    },
    //我的代码
    initChart(){
      let _this = this
        let myChart = this.$echarts.init(document.getElementById('myecharts'));
        myChart.setOption({
          tooltip: {
              trigger: 'axis'
          },
          grid: {
              left: '5%',
              right: '4%',
              bottom: '3%',
              containLabel: true
          },
          toolbox: {
              feature: {
                  saveAsImage: {}
              }
          },
          xAxis: {
              type: 'category',
              axisLabel: {
              rotate: 60,
              },
              data: _this.timeArr
          },
          yAxis: {
              type: 'value'
          },
          series: [
              {
                  name:'Step End',
                  type:'line',
                  step: 'end',
                  data:_this.numArr
              }
          ]
        })//setOption
    }, 
    searchers(){//Eventcode接口
      let _this = this
      this.axios({
        method:'post',
        url:'url/findAnalogValueCodesList',
        params:{
          machineId: _this.tbmid,
          startTime:_this.datevalue1+' '+_this.timevalue1
        }
      }).then(function(res){
        _this.searcherslist = res.data
        if(_this.searcherslist.length === 0){
              _this.searchvalue = ''
        }
      })
    },
    showstart(){//折线图接口
      let _this = this
      this.axios({
        method:'post',
        url:'url/selectAnalogValueAnalysis',
        params:{//参数
          machineId: _this.tbmid,
          codes:_this.searchid,
          startTime:_this.datevalue1+' '+_this.timevalue1,
          endTime:_this.datevalue1+' '+_this.timevalue2,  
          language:_this.$store.state.lang
        }
      }).then(function(res){
        _this.myecharts = false
        if(res.data.success === 'true'){
          _this.timeArr = []
          _this.numArr = []
          for (const item of res.data.machineAnalogLogs) {
              _this.numArr.push(item.msgValue)//y
              _this.timeArr.push(item.timeStampString)//x
            }
        }else {
          _this.open3(res.data.msg)
          _this.timeArr = []
          _this.numArr = []
        }
      }).then(function(){
        _this.initChart()
      })
    },
    datevaluechange(){
      if(this.datevalue === null){
          return
        }
      let y = this.datevalue.getFullYear();
      let m = this.datevalue.getMonth()+1; 
        if(m<10){
          m ='0'+ m
        }
      let d = this.datevalue.getDate(); 
        if(d<10){
          d ='0'+ d
        }
      this.datevalue1 = y +'/'+ m +'/'+ d;
    },
    timevaluechange(){
        if(this.timevalue === ''){
          return
        }
      let h = this.timevalue.getHours(); 
      let h1 = h
      if(h<10){
          h ='0'+ h
        }
      let min = this.timevalue.getMinutes(); 
      let min2 = min
        if(min<10){
          min ='0'+ min
        }
      let s = this.timevalue.getSeconds(); 
      let ss = (s+5)
        if(s<10){
          s ='0'+ s
        }
        if(ss<10){
          ss ='0'+ ss
        }
      this.timevalue1 = h +':'+ min +':'+ s ;
      if(s>54){
        ss = `0${ss-60}`;
        min = (min2+1)
        if(min<10){
          min ='0'+ min
        }else if(min>59){
          min = `0${min-60}`
          h = (h1+1)
          if(h<10){
            h ='0'+ h
          }else if(h>23){
            h = '00';
            min = '00';
          }
        }
      }
      this.timevalue2 = h +':'+ min +':'+ ss;
    },
    open4() {//未选全条件，弹出弹框
        if(this.machineID.length === 0){//请选择设备
          this.$message.error(this.$t('AnalogValueAnalysis.equipment'));
        }else if(this.datevalue === '' || this.datevalue === null){//请选择日期
          this.$message.error(this.$t('AnalogValueAnalysis.pChoosedate'));
            this.myecharts = false
        }else if(this.timevalue === '' || this.timevalue === null){//请选择时间
          this.$message.error(this.$t('AnalogValueAnalysis.pChoosetime'));
            this.myecharts = false
        }else if(this.searchvalue === ''){//请选择事件编码
          this.$message.error(this.$t('AnalogValueAnalysis.selectEventCode'));
            this.myecharts = false
        }else{
          this.importantbody = true
          this.showstart()
        }
    },
    open3(x){
      this.$message.error(x);
    },
    searchstart(){
      this.myecharts = true //echarts图表
      this.open4()
    },
    kongdata(x){
      if(x === null){
          this.datevalue1 = ''
          this.datevalue = ''
      }else{//当时间和日期都有值时，请求code数据
        if(this.timevalue !== null && this.timevalue !== ''){
          this.searchers()
        }
      }
    },
    kongtime(x){
      if(x === null){
          this.timevalue1 = ''
          this.timevalue2 = ''
          this.timevalue = ''
      }else{//当时间和日期都有值时，请求code数据
        if(this.datevalue !== null && this.datevalue !== ''){
          this.searchers()
        }
      }
    }
  }
}
</script>
<style scoped>
.AnalogValueAnalysis{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
}
.seach button{
  float: right;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.recordTitle .machineSeach{
  float: right;
  display:flex;
  align-items: center;
}
/* 我的样式 */
.my{
  height: 800px;
  width: 100%;
}
.mynavlist{
  width: 94%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0 15px 0;
}
.mynavlist .navlistleft{
  width: 100%;
  display: flex;
  flex-direction: row;
}
.mynavlist .navlistleft .searchers{
  width: 160px;
}
.mynavlist .navlistleft .searchnavdate{
  width: 150px;
}
.mynavlist .navlistleft .searchnavtime{
  width: 150px;
  margin: 0 14px 0 14px;
}
.navlistright .searchstart{
  width: 95px;
}
.importantbody{
  width: 94%;
  height: 86%;
  padding: 27px 0 10px;
  background: #fff;
  margin: 0 auto;
  color: rgba(80, 80, 80, 1);
}
.importantbody .selectsort{
  text-align: center;
  line-height: 27px;
  font-size:18px;
  font-weight: 700;
  margin-bottom: 6px;
}
.importantbody .selecttime{
  text-align: center;
  line-height: 21px;
  font-size:14px;
  margin-bottom: 14px;
}
.importantbody .selecttime .blank{
  margin-left: 5px;
}
#myecharts{
    width: 796px;
    height: 535px;
    margin:0 auto;
    background: #efefef;
}
/* element-ui样式 */
.mynavlist .navlistleft .searchers .el-select .el-input #EventCode{
    width: 160px;
}
.searchnavdate .block .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 150px;
}
.searchnavtime .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 150px;
}
</style>

